import LayoutActividad from "../../../components/LayoutActividad";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad3Actividad3.mp3";

const Actividad6 = () => {
  const infoUnidad = modulo14.content[2];
  const infoAct = modulo14.content[2].activities[3];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[2].name}: ${modulo14.content[2].activities[4].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[4].path}`,
    titlePrev: `${modulo14.content[2].name}: ${modulo14.content[2].activities[2].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[2].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>
      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-10 col-12">
          <ul>
            <li>
              La ley peruana dice que los idiomas oficiales del Perú son el
              castellano y las lenguas originarias en los distritos, provincias
              y regiones donde predominan.
            </li>
            <li>
              Lee las siguientes oraciones y da ejemplos de a qué se refieren la
              frases resaltadas.
            </li>
          </ul>
          <div className="row mt-5">
            <div className="col-md-10 ps-lg-5 ps-0">
              <div className="border-2 shadow-sm border rounded px-4">
                <p className="mt-3 fs-5">
                  1. Cualquiera debería poder utilizar su lengua ante las{" "}
                  <strong>instituciones del Estado</strong>.
                </p>
              </div>
            </div>
            <div className="col-md-12 ps-lg-5 ps-0 mt-4">
              <p className="text-sm">
                <strong>Ejemplos de instituciones del Estado: </strong>
              </p>
              <textarea rows={"6"} className="form-control w-100" />
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-md-10 ps-lg-5 ps-0">
              <div className="border-2 shadow-sm border rounded px-4">
                <p className="mt-3 fs-5">
                  2. Los hablantes de{" "}
                  <strong>lenguas originarias del Perú</strong> tienen
                  dificultades porque algunos servicios solo se brindan en
                  castellano.
                </p>
              </div>
            </div>
            <div className="col-md-12 ps-lg-5 ps-0 mt-4">
              <p className="text-sm">
                <strong>Ejemplos de lenguas originarias del Perú: </strong>
              </p>

              <textarea rows={"6"} className="form-control w-100" />
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-5">
        <div className="col-lg-10 col-12">
          <ul>
            <li>
              Ahora busca una noticia que sea un ejemplo positivo en el que una
              institución del Estado atienda a un hablante de una lengua
              originaria en su lengua. Copia el título de la noticia en el
              siguiente recuadro.
            </li>
          </ul>
          <div className="px-3">
            <textarea className="form-control" rows="6" />
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique que en las siguientes actividades se desarrollarán ciertos
            conceptos que buscan aproximarnos a la comprensión de los problemas
            que ocurren en el Perú debido a que no se enfrenta adecuadamente la
            diversidad lingüística.
          </li>
          <li>
            Pida a un o una estudiante que lea en voz alta la primera
            afirmación: La ley peruana dice que los idiomas oficiales del Perú
            son el castellano y las lenguas originarias en los distritos,
            provincias y regiones donde predominan. Lea la primera indicación:
            Lee las siguientes oraciones y da ejemplos de a qué se refieren la
            frases resaltadas. Pida a un o una estudiante que lea las dos
            oraciones propuestas.
          </li>
          <li>
            Déles un tiempo para que trabajen individualmente. Retome las
            respuestas y lea nuevamente las oraciones. Esta vez, pídales que
            reemplacen las frases destacadas en negritas con sus ejemplos. Por
            ejemplo:
            <ul>
              <li>
                <i>
                  “Cualquiera debería poder utilizar su lengua ante la posta, el
                  poder judicial, la escuela, la comisaría, etc.”.
                </i>
              </li>
              <li>
                <i>
                  “Los hablantes de quechua, aymara y awajún tienen dificultades
                  porque algunos servicios solo se brindan en castellano”.
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad6;
